import React, {Component, ReactNode} from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {closeMenuAndScrollToTop, getLinkPath} from 'app/utils';
import {countedTitle} from 'app/utils/countedTitle';
import {getPromoUrl} from 'app/utils/getPromoUrl';
import {ArticlesStore} from 'app/store/ArticlesStore';
import {inject, observer} from 'mobx-react';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface UserNavBottomProps {
    articlesStore?: ArticlesStore
    onClose?: () => void;
}

@inject('articlesStore')
@observer
class UserNavBottom extends Component<UserNavBottomProps> {
    onClose = (): void => {
        this.props.onClose?.();
        closeMenuAndScrollToTop();
    };

    render(): ReactNode {
        return <>
            <Link
                className="user-nav__item"
                to={getLinkPath('/my_profile/referrals')}
                onClick={this.onClose}
            >
                <span className="user-nav__icon">
                    <SpriteIcon name="#svg-referrals" size={{height: 19, width: 18}}/>
                </span>
                <span>{I18n.t('my_referrals')}</span>
            </Link>
            <Link
                className="user-nav__item"
                to={getLinkPath(getPromoUrl())}
                onClick={this.onClose}
            >
                <span className="user-nav__icon">
                    <SpriteIcon name="#svg-promo_action" size={{height: 19, width: 18}}/>
                </span>
                <span>{countedTitle(I18n.t('promo_actions'), this.props.articlesStore.activePromoNewCount)}</span>
            </Link>
        </>;
    }
}

export default UserNavBottom;
